import React from "react";
import { IIcons } from "./icons";

const Minus = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#D3E2FF" className={fillColor} />
      <path d="M13.3569 8.95312V10.0618H6.99805V8.95312H13.3569Z" fill="#FFFFFF" />
      <path d="M13.3569 8.95312V10.0618H6.99805V8.95312H13.3569Z" fill="#FFFFFF" />
    </svg>
  );
};

export default Minus;
